import { FormattedMessage } from 'react-intl';
import { matchPath, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import Button from '@sorare/core/src/atoms/buttons/Button';
import ScarcityIcon from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { SwapBudget } from '@sorare/core/src/atoms/icons/SwapBudget';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import {
  NBA_S3_SWAP_ADD_A_CARD,
  NBA_S3_SWAP_DROP_A_CARD,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

const Root = styled(FullWidthContainer)`
  padding-top: var(--unit);
  padding-bottom: var(--unit);
  background-color: var(--c-neutral-300);
`;

const Row = styled(Horizontal)`
  justify-content: space-between;
`;

const ButtonWrap = styled(Horizontal)`
  padding: var(--half-unit);
  border-radius: var(--triple-unit);
  background-color: var(--c-neutral-400);
`;

export const SwapHeader = () => {
  const location = useLocation();

  const buying = matchPath(location.pathname, NBA_S3_SWAP_ADD_A_CARD);
  const selling = matchPath(location.pathname, NBA_S3_SWAP_DROP_A_CARD);
  const { currentUser } = useCurrentUserContext();
  const pointsCount = currentUser?.nbaCommonCardPoints || 0;
  const cardsCount = currentUser?.nbaUserProfile?.cardsCount?.common || 0;
  if (!currentUser) return null;
  return (
    <Root>
      <Row>
        <Horizontal gap={1}>
          <SwapBudget />
          <LabelM as="span" color="var(--c-neutral-1000)">
            <FormattedMessage
              id="SwapHeader.pointsCount"
              defaultMessage="{pointsCount} points"
              values={{ pointsCount }}
            />
          </LabelM>
          <LabelM as="span" color="var(--c-neutral-500)">
            •
          </LabelM>
          <ScarcityIcon scarcity={Rarity.common} />
          <LabelM
            as="span"
            color={
              cardsCount < 9 ? 'var(--c-yellow-600)' : 'var(--c-neutral-1000)'
            }
          >
            {cardsCount}
          </LabelM>
        </Horizontal>

        <ButtonWrap>
          <Button
            size="small"
            to={NBA_S3_SWAP_ADD_A_CARD}
            color={buying ? 'secondary' : 'transparent'}
          >
            <FormattedMessage id="SwapHeader.switch.add" defaultMessage="Add" />
          </Button>
          <Button
            size="small"
            to={NBA_S3_SWAP_DROP_A_CARD}
            color={selling ? 'secondary' : 'transparent'}
          >
            <FormattedMessage
              id="SwapHeader.switch.drop"
              defaultMessage="Drop"
            />
          </Button>
        </ButtonWrap>
      </Row>
    </Root>
  );
};
